import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SidePanelComponent} from './side-panel/side-panel.component';
import {HttpClientModule} from '@angular/common/http';
import {HttpFilterService} from '../services/http/http-filter.service';
import {ProjectListComponent} from './project-list/project-list.component';
import {ProjectDetailComponent} from './project-detail/project-detail.component';
import {TrustHtmlPipe} from './pipes/trust-html.pipe';
import {ProjetcGraphsComponent} from './projetc-graphs/projetc-graphs.component';
import { ChartComponent } from './projetc-graphs/chart/chart.component';
import { ChartsModule } from 'ng2-charts';
import { CzechNumberFormatPipe } from './pipes/czech-number-format.pipe';
import {ChartFunctionLibraryModule} from 'chart-function-library';
import {EasyChartsModule} from '@easycomp/easy-charts';
import { MainPageComponent } from './main-page/main-page.component';
import {Ng2OdometerModule} from 'ng2-odometer';
import { LightboxModule } from 'ngx-lightbox';

@NgModule({
    declarations: [
        AppComponent,
        SidePanelComponent,
        ProjectListComponent,
        ProjectDetailComponent,
        TrustHtmlPipe,
        ProjetcGraphsComponent,
        ChartComponent,
        CzechNumberFormatPipe,
        MainPageComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        NgSelectModule,
        FormsModule,
        ChartsModule,
        ReactiveFormsModule,
        ChartFunctionLibraryModule,
        EasyChartsModule,
        Ng2OdometerModule.forRoot(),
        LightboxModule

    ],
    providers: [
        HttpFilterService,
        CzechNumberFormatPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
